var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"firstPage"},[_c('big-screen'),_c('i',{staticClass:"el-icon-full-screen fullScreen ",attrs:{"title":"全屏"},on:{"click":_vm.seeView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }